import { render, staticRenderFns } from "./DashboardListPanel.vue?vue&type=template&id=16b286a3&scoped=true&"
import script from "./DashboardListPanel.vue?vue&type=script&lang=ts&"
export * from "./DashboardListPanel.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardListPanel.vue?vue&type=style&index=0&id=16b286a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b286a3",
  null
  
)

export default component.exports